import { Action } from 'redux';
export enum AiTextItemType {
    GENERATE = 'generate',
    IMPROVE = 'improve',
}
export interface AiTextItem {
    type: AiTextItemType;
    timestamp: number;
    context: string;
    request: string;
    response?: string;
    isTimeout?: boolean;
}

export enum ActionTypes {
    SET_INPUT_VALUE = '@@aiText/SET_INPUT_VALUE',
    GENERATE_START_CHECK = '@@aiText/GENERATE_START_CHECK',
    GENERATE_START = '@@aiText/GENERATE_START',
    GENERATE_WAIT = '@@aiText/GENERATE_WAIT',
    GENERATE_END = '@@aiText/GENERATE_END',
}
export interface AiTextSetInputValueAction extends Action {
    type: ActionTypes.SET_INPUT_VALUE;
    payload: { value: string };
}

export interface AiTextGenerateStartCheckAction extends Action {
    type: ActionTypes.GENERATE_START_CHECK;
    payload: { item: AiTextItem };
}
export interface AiTextGenerateStartAction extends Action {
    type: ActionTypes.GENERATE_START;
    payload: { item: AiTextItem };
}

export interface AiTextGenerateWaitAction extends Action {
    type: ActionTypes.GENERATE_WAIT;
    payload: { item: AiTextItem; conversationId: string; numberOfTries?: number };
}

export interface AiTextGenerateEndAction extends Action {
    type: ActionTypes.GENERATE_END;
    payload: { item: AiTextItem };
}

export interface AiTextState {
    list: AiTextItem[];
    isBusy: boolean;
    inputValue: string;
}
